<div class="aca-admin aca-frb">
  <aca-page-header icon="dynamic_form" [title]="'DMS.FORMS.BUILDER_TITLE' | translate" [subtitle]="'DMS.FORMS.BUILDER_SUBTITLE' | translate">
    <a class="aca-frb__outline" routerLink="/forms"><mat-icon>arrow_back</mat-icon>{{ 'DMS.FORMS.BACK' | translate }}</a>
    <button type="button" class="aca-frb__outline" (click)="printBlank()" [disabled]="!!working()">
      <mat-icon>picture_as_pdf</mat-icon
      >{{ (working() === 'pdf' ? 'DMS.FORMS.PRINTING' : model.paper ? 'DMS.FORMS.PRINT_SAMPLE' : 'DMS.FORMS.PRINT_BLANK') | translate }}
    </button>
    <button type="button" class="aca-frb__outline" (click)="save()" [disabled]="!!working() || loading()">
      <mat-icon>save</mat-icon>{{ 'DMS.FORMS.SAVE' | translate }}
    </button>
    <button type="button" class="aca-frb__primary" (click)="save(true)" [disabled]="!!working() || loading()">
      <mat-icon>publish</mat-icon>{{ (model.status === 'published' ? 'DMS.FORMS.SAVE_PUBLISHED' : 'DMS.FORMS.PUBLISH') | translate }}
    </button>
  </aca-page-header>

  <mat-progress-bar mode="indeterminate" *ngIf="loading() || working() === 'save'" />
  <aca-page-state *ngIf="failed()" state="error" [title]="'DMS.FORMS.OPEN_FAILED' | translate" [message]="failed()" />

  <ng-container *ngIf="!loading() && !failed()">
    <p class="aca-frb__drafted" *ngIf="drafted() && !model.id" role="status">
      <mat-icon>auto_awesome</mat-icon>
      <span
        ><strong>{{ 'DMS.FORMS.DRAFTED' | translate: { source: drafted()!.source, model: drafted()!.model || '' } }}</strong>
        {{ 'DMS.FORMS.DRAFTED_CHECK' | translate }}</span
      >
    </p>
    <!-- ── status line ────────────────────────────────────────────────── -->
    <div class="aca-frb__statusline">
      <span class="aca-frb__chip aca-frb__chip--{{ model.status }}">{{ 'DMS.FORMS.STATUS_' + model.status.toUpperCase() | translate }}</span>
      <span>{{ 'DMS.FORMS.VERSION' | translate: { version: model.version } }}</span>
      <span class="aca-frb__dirty" *ngIf="dirty"><mat-icon>edit</mat-icon>{{ 'DMS.FORMS.UNSAVED' | translate }}</span>
      <span class="aca-frb__problems" *ngIf="problems.length">
        <mat-icon>error_outline</mat-icon>
        <span *ngFor="let problem of problems; let last = last">{{ 'DMS.FORMS.PROBLEM_' + problem | translate }}{{ last ? '' : ' · ' }}</span>
      </span>
      <span class="aca-frb__ok" *ngIf="!problems.length"><mat-icon>check_circle</mat-icon>{{ 'DMS.FORMS.READY' | translate }}</span>
      <span class="aca-frb__spacer"></span>
      <div class="aca-frb__tabs" role="tablist">
        <button
          type="button"
          role="tab"
          class="aca-frb__tab"
          [class.aca-frb__tab--on]="tab() === 'design'"
          [attr.aria-selected]="tab() === 'design'"
          (click)="showTab('design')"
        >
          <mat-icon>design_services</mat-icon>{{ 'DMS.FORMS.TAB_DESIGN' | translate }}
        </button>
        <button
          type="button"
          role="tab"
          class="aca-frb__tab"
          *ngIf="model.paper"
          [class.aca-frb__tab--on]="tab() === 'paper'"
          [attr.aria-selected]="tab() === 'paper'"
          (click)="showTab('paper')"
        >
          <mat-icon>picture_in_picture</mat-icon>{{ 'DMS.FORMS.TAB_PAPER' | translate }}
        </button>
        <button
          type="button"
          role="tab"
          class="aca-frb__tab"
          [class.aca-frb__tab--on]="tab() === 'preview'"
          [attr.aria-selected]="tab() === 'preview'"
          (click)="showTab('preview')"
        >
          <mat-icon>visibility</mat-icon>{{ 'DMS.FORMS.TAB_PREVIEW' | translate }}
        </button>
      </div>
    </div>

    <!-- ── preview: the fill-in page itself ───────────────────────────── -->
    <app-form-fill *ngIf="tab() === 'preview'" [definition]="previewModel" [preview]="true" />

    <!-- ── the organisation's own paper ───────────────────────────────── -->
    <app-form-paper *ngIf="tab() === 'paper' && model.paper" [form]="model" (testPrint)="printBlank()" />

    <!-- ── design ─────────────────────────────────────────────────────── -->
    <div class="aca-frb__editor" *ngIf="tab() === 'design'" cdkDropListGroup>
      <!-- palette -->
      <aside class="aca-frb__palette">
        <h2 class="aca-frb__panetitle">{{ 'DMS.FORMS.PALETTE' | translate }}</h2>
        <p class="aca-frb__panehint">{{ 'DMS.FORMS.PALETTE_HINT' | translate }}</p>
        <div
          id="aca-frb-palette"
          class="aca-frb__palettelist"
          cdkDropList
          cdkDropListSortingDisabled
          [cdkDropListData]="fieldTypes"
          [cdkDropListEnterPredicate]="noDropOnPalette"
        >
          <button type="button" *ngFor="let t of fieldTypes" class="aca-frb__paletteitem" cdkDrag [cdkDragData]="t.type" (click)="addField(t.type)">
            <span class="aca-frb__paletteicon aca-frb__paletteicon--{{ t.tone }}"
              ><mat-icon>{{ t.icon }}</mat-icon></span
            >
            {{ 'DMS.FORMS.TYPE_' + t.type.toUpperCase() | translate }}
          </button>
        </div>
      </aside>

      <!-- canvas -->
      <section class="aca-frb__canvas" (click)="selectForm()" (keydown.escape)="selectForm()" tabindex="-1">
        <div class="aca-frb__formhead" [class.aca-frb__formhead--on]="selection.kind === 'form'">
          <label class="aca-sr-only" for="frb-title">{{ 'DMS.FORMS.FORM_TITLE' | translate }}</label>
          <input
            id="frb-title"
            class="aca-frb__titleinput"
            [(ngModel)]="model.title"
            [placeholder]="'DMS.FORMS.FORM_TITLE_PLACEHOLDER' | translate"
            (click)="$event.stopPropagation(); selectForm()"
          />
          <label class="aca-sr-only" for="frb-desc">{{ 'DMS.FORMS.FORM_DESCRIPTION' | translate }}</label>
          <input
            id="frb-desc"
            class="aca-frb__descinput"
            [(ngModel)]="model.description"
            [placeholder]="'DMS.FORMS.FORM_DESCRIPTION_PLACEHOLDER' | translate"
            (click)="$event.stopPropagation(); selectForm()"
          />
        </div>

        <div
          class="aca-frb__section"
          *ngFor="let section of model.sections; let s = index"
          [class.aca-frb__section--on]="isSelected(s)"
          (click)="$event.stopPropagation(); selectSection(s)"
          (keydown.enter)="selectSection(s)"
          tabindex="-1"
        >
          <div class="aca-frb__sectionhead">
            <mat-icon class="aca-frb__sectionicon">view_agenda</mat-icon>
            <label class="aca-sr-only" [for]="'frb-section-' + s">{{ 'DMS.FORMS.SECTION_TITLE' | translate }}</label>
            <input
              [id]="'frb-section-' + s"
              class="aca-frb__sectioninput"
              [(ngModel)]="section.title"
              [placeholder]="'DMS.FORMS.SECTION_TITLE_PLACEHOLDER' | translate: { n: s + 1 }"
              [attr.aria-label]="'DMS.FORMS.SECTION_TITLE_PLACEHOLDER' | translate: { n: s + 1 }"
            />
            <button
              type="button"
              class="aca-frb__icon"
              (click)="moveSection(s, -1)"
              [disabled]="s === 0"
              [attr.aria-label]="'DMS.FORMS.MOVE_UP' | translate"
            >
              <mat-icon>arrow_upward</mat-icon>
            </button>
            <button
              type="button"
              class="aca-frb__icon"
              (click)="moveSection(s, 1)"
              [disabled]="s === model.sections.length - 1"
              [attr.aria-label]="'DMS.FORMS.MOVE_DOWN' | translate"
            >
              <mat-icon>arrow_downward</mat-icon>
            </button>
            <button
              type="button"
              class="aca-frb__icon aca-frb__icon--danger"
              (click)="$event.stopPropagation(); removeSection(s)"
              [disabled]="model.sections.length === 1"
              [attr.aria-label]="'DMS.FORMS.REMOVE_SECTION' | translate"
            >
              <mat-icon>delete_outline</mat-icon>
            </button>
          </div>
          <span class="aca-frb__fieldcond aca-frb__fieldcond--section" *ngIf="section.showIf as condition"
            ><mat-icon>visibility</mat-icon>{{ conditionSummary(condition) }}</span
          >

          <div
            class="aca-frb__fields"
            [class.aca-frb__fields--two]="section.columns === 2"
            cdkDropList
            [id]="'aca-frb-section-' + s"
            [cdkDropListData]="section.fields"
            (cdkDropListDropped)="drop($event, s)"
          >
            <p class="aca-frb__emptysection" *ngIf="!section.fields.length">{{ 'DMS.FORMS.EMPTY_SECTION' | translate }}</p>
            <div
              *ngFor="let field of section.fields; let f = index"
              class="aca-frb__field"
              [class.aca-frb__field--wide]="section.columns !== 2 || field.width !== 'half' || isWideType(field.type)"
              [class.aca-frb__field--on]="isSelected(s, f)"
              cdkDrag
              (click)="selectField(s, f, $event)"
              (keydown.enter)="selectField(s, f, $event)"
              tabindex="0"
              role="button"
              [attr.aria-pressed]="isSelected(s, f)"
            >
              <mat-icon class="aca-frb__grip" cdkDragHandle>drag_indicator</mat-icon>
              <mat-icon class="aca-frb__fieldicon">{{ typeIcon(field.type) }}</mat-icon>
              <span class="aca-frb__fieldtext">
                <span class="aca-frb__fieldlabel">
                  {{ field.type === 'paragraph' ? field.text || field.label : field.label || ('DMS.FORMS.NO_LABEL' | translate)
                  }}<span class="aca-frb__req" *ngIf="field.required"> *</span>
                </span>
                <span class="aca-frb__fieldmeta">
                  {{ typeLabel(field.type) }}<ng-container *ngIf="field.type !== 'paragraph'"> · {{ field.key }}</ng-container
                  ><ng-container *ngIf="field.metadata"> · {{ field.metadata }}</ng-container
                  ><ng-container *ngIf="field.type === 'calc' && field.formula"> · = {{ field.formula }}</ng-container>
                </span>
                <span class="aca-frb__fieldcond" *ngIf="field.showIf as condition" [attr.title]="conditionSummary(condition)"
                  ><mat-icon>visibility</mat-icon>{{ conditionSummary(condition) }}</span
                >
              </span>
              <div class="aca-frb__dropph" *cdkDragPlaceholder></div>
            </div>
          </div>
        </div>

        <button type="button" class="aca-frb__addsection" (click)="$event.stopPropagation(); addSection()">
          <mat-icon>add</mat-icon>{{ 'DMS.FORMS.ADD_SECTION' | translate }}
        </button>
      </section>

      <!-- properties -->
      <aside class="aca-frb__props">
        <!-- a field -->
        <ng-container *ngIf="selectedField as field">
          <h2 class="aca-frb__panetitle">
            <mat-icon>{{ typeIcon(field.type) }}</mat-icon
            >{{ typeLabel(field.type) }}
          </h2>

          <ng-container *ngIf="field.type !== 'paragraph'">
            <label class="aca-frb__label" for="frb-label">{{
              (field.type === 'checkbox' ? 'DMS.FORMS.STATEMENT' : 'DMS.FORMS.LABEL') | translate
            }}</label>
            <input id="frb-label" class="aca-frb__input" [(ngModel)]="field.label" />

            <label class="aca-frb__label" for="frb-key">{{ 'DMS.FORMS.KEY' | translate }}</label>
            <input id="frb-key" class="aca-frb__input aca-frb__input--mono" [(ngModel)]="field.key" (blur)="tidyKey(field)" />
            <span class="aca-frb__hint">{{ 'DMS.FORMS.KEY_HINT' | translate }}</span>

            <label class="aca-frb__check" for="frb-required" *ngIf="field.type !== 'calc'">
              <input id="frb-required" type="checkbox" [(ngModel)]="field.required" />{{ 'DMS.FORMS.REQUIRED' | translate }}
            </label>
          </ng-container>

          <ng-container *ngIf="field.type === 'calc'">
            <label class="aca-frb__label" for="frb-formula">{{ 'DMS.FORMS.FORMULA' | translate }}</label>
            <textarea
              id="frb-formula"
              class="aca-frb__input aca-frb__input--mono aca-frb__input--formula"
              rows="2"
              spellcheck="false"
              placeholder="qty * price"
              [(ngModel)]="field.formula"
            ></textarea>
            <span class="aca-frb__fieldproblem" *ngIf="formulaProblem(field) as problem" role="alert"
              ><mat-icon>error_outline</mat-icon>{{ problem }}</span
            >
            <span class="aca-frb__hint">{{ 'DMS.FORMS.FORMULA_HINT' | translate }}</span>
            <div class="aca-frb__names" *ngIf="formulaNames(field).length" role="group" [attr.aria-label]="'DMS.FORMS.FORMULA_NAMES' | translate">
              <button
                type="button"
                class="aca-frb__name"
                *ngFor="let name of formulaNames(field); trackBy: trackName"
                (click)="insertName(field, name.insert)"
              >
                {{ name.label }}<code>{{ name.insert }}</code>
              </button>
            </div>
            <span class="aca-frb__label" id="frb-format-label">{{ 'DMS.FORMS.FORMAT' | translate }}</span>
            <div class="aca-frb__seg" role="radiogroup" aria-labelledby="frb-format-label">
              <button
                type="button"
                role="radio"
                [attr.aria-checked]="field.format !== 'number'"
                [class.aca-frb__seg--on]="field.format !== 'number'"
                (click)="field.format = 'money'"
              >
                {{ 'DMS.FORMS.FORMAT_MONEY' | translate }}
              </button>
              <button
                type="button"
                role="radio"
                [attr.aria-checked]="field.format === 'number'"
                [class.aca-frb__seg--on]="field.format === 'number'"
                (click)="field.format = 'number'"
              >
                {{ 'DMS.FORMS.FORMAT_NUMBER' | translate }}
              </button>
            </div>
          </ng-container>

          <ng-container *ngIf="field.type === 'paragraph'">
            <label class="aca-frb__label" for="frb-text">{{ 'DMS.FORMS.PARAGRAPH_TEXT' | translate }}</label>
            <textarea id="frb-text" class="aca-frb__input aca-frb__input--long" rows="5" [(ngModel)]="field.text"></textarea>
          </ng-container>

          <ng-container *ngIf="model.sections[selectedSectionIndex]?.columns === 2 && !isWideType(field.type)">
            <span class="aca-frb__label" id="frb-width-label">{{ 'DMS.FORMS.WIDTH' | translate }}</span>
            <div class="aca-frb__seg" role="radiogroup" aria-labelledby="frb-width-label">
              <button
                type="button"
                role="radio"
                [attr.aria-checked]="field.width === 'half'"
                [class.aca-frb__seg--on]="field.width === 'half'"
                (click)="field.width = 'half'"
              >
                {{ 'DMS.FORMS.WIDTH_HALF' | translate }}
              </button>
              <button
                type="button"
                role="radio"
                [attr.aria-checked]="field.width !== 'half'"
                [class.aca-frb__seg--on]="field.width !== 'half'"
                (click)="field.width = 'full'"
              >
                {{ 'DMS.FORMS.WIDTH_FULL' | translate }}
              </button>
            </div>
          </ng-container>

          <ng-container *ngIf="hasOptions(field)">
            <label class="aca-frb__label" for="frb-options">{{ 'DMS.FORMS.OPTIONS' | translate }}</label>
            <textarea
              id="frb-options"
              class="aca-frb__input aca-frb__input--long"
              rows="5"
              [ngModel]="optionsText(field)"
              (ngModelChange)="setOptions(field, $event)"
              [ngModelOptions]="{ updateOn: 'blur' }"
            ></textarea>
            <span class="aca-frb__hint">{{ 'DMS.FORMS.OPTIONS_HINT' | translate }}</span>
          </ng-container>

          <ng-container *ngIf="field.type === 'table'">
            <span class="aca-frb__label">{{ 'DMS.FORMS.COLUMNS' | translate }}</span>
            <div class="aca-frb__column" *ngFor="let column of field.columns; let c = index">
              <label class="aca-sr-only" [for]="'frb-col-' + c">{{ 'DMS.FORMS.COLUMN_LABEL' | translate }}</label>
              <input
                [id]="'frb-col-' + c"
                class="aca-frb__input"
                [(ngModel)]="column.label"
                [placeholder]="'DMS.FORMS.COLUMN_LABEL' | translate"
                [attr.aria-label]="'DMS.FORMS.COLUMN_LABEL' | translate"
              />
              <label class="aca-sr-only" [for]="'frb-coltype-' + c">{{ 'DMS.FORMS.COLUMN_TYPE' | translate }}</label>
              <select
                [id]="'frb-coltype-' + c"
                class="aca-frb__input aca-frb__input--narrow"
                [(ngModel)]="column.type"
                (ngModelChange)="columnTypeChanged(column)"
              >
                <option *ngFor="let t of columnTypes" [value]="t">{{ 'DMS.FORMS.TYPE_' + t.toUpperCase() | translate }}</option>
              </select>
              <button
                type="button"
                class="aca-frb__icon aca-frb__icon--danger"
                (click)="removeColumn(field, c)"
                [disabled]="(field.columns?.length ?? 0) < 2"
                [attr.aria-label]="'DMS.FORMS.REMOVE_COLUMN' | translate"
              >
                <mat-icon>close</mat-icon>
              </button>
              <div class="aca-frb__colcalc" *ngIf="column.type === 'calc'">
                <span class="aca-frb__colkey">{{ column.key }} =</span>
                <label class="aca-sr-only" [for]="'frb-colformula-' + c">{{ 'DMS.FORMS.FORMULA' | translate }}</label>
                <input
                  [id]="'frb-colformula-' + c"
                  class="aca-frb__input aca-frb__input--mono"
                  spellcheck="false"
                  placeholder="qty * price"
                  aria-label="qty * price"
                  [(ngModel)]="column.formula"
                />
                <div class="aca-frb__names" *ngIf="columnNames(field, column).length">
                  <button
                    type="button"
                    class="aca-frb__name"
                    *ngFor="let name of columnNames(field, column); trackBy: trackName"
                    (click)="insertName(column, name.insert)"
                  >
                    {{ name.label }}<code>{{ name.insert }}</code>
                  </button>
                </div>
                <span class="aca-frb__fieldproblem" *ngIf="columnFormulaProblem(field, column) as problem" role="alert"
                  ><mat-icon>error_outline</mat-icon>{{ problem }}</span
                >
              </div>
            </div>
            <button type="button" class="aca-frb__link" (click)="addColumn(field)">
              <mat-icon>add</mat-icon>{{ 'DMS.FORMS.ADD_COLUMN' | translate }}
            </button>
          </ng-container>

          <ng-container *ngIf="field.type === 'signature'">
            <label class="aca-frb__check" for="frb-infooter">
              <input id="frb-infooter" type="checkbox" [(ngModel)]="field.inFooter" [disabled]="!footer.signatures.length && !field.inFooter" />{{
                'DMS.FORMS.SIGN_IN_FOOTER' | translate
              }}
            </label>
            <span class="aca-frb__hint">{{
              (footer.signatures.length ? 'DMS.FORMS.SIGN_IN_FOOTER_HINT' : 'DMS.FORMS.SIGN_IN_FOOTER_NO_BOXES')
                | translate: { box: footer.signatures[0] || '' }
            }}</span>
          </ng-container>

          <span class="aca-frb__hint" *ngIf="field.type === 'address'">{{ 'DMS.FORMS.ADDRESS_BUILDER_HINT' | translate }}</span>

          <ng-container *ngIf="['text', 'textarea', 'number', 'money', 'email', 'phone', 'thaiId'].indexOf(field.type) >= 0">
            <label class="aca-frb__label" for="frb-placeholder">{{ 'DMS.FORMS.PLACEHOLDER' | translate }}</label>
            <input id="frb-placeholder" class="aca-frb__input" [(ngModel)]="field.placeholder" />
          </ng-container>

          <ng-container *ngIf="field.type !== 'paragraph'">
            <label class="aca-frb__label" for="frb-help">{{ 'DMS.FORMS.HELP' | translate }}</label>
            <input id="frb-help" class="aca-frb__input" [(ngModel)]="field.help" />
          </ng-container>

          <ng-container *ngIf="metadataTargets(field).length">
            <label class="aca-frb__label" for="frb-metadata">{{ 'DMS.FORMS.METADATA' | translate }}</label>
            <select id="frb-metadata" class="aca-frb__input" [(ngModel)]="field.metadata">
              <option [ngValue]="undefined">{{ 'DMS.FORMS.METADATA_NONE' | translate }}</option>
              <option *ngFor="let property of metadataTargets(field)" [ngValue]="property">
                {{ 'DMS.FORMS.META_' + property.replace('dms:', '').toUpperCase() | translate }}
              </option>
            </select>
            <span class="aca-frb__hint">{{ 'DMS.FORMS.METADATA_HINT' | translate }}</span>
          </ng-container>

          <ng-container *ngTemplateOutlet="conditionEditor; context: { $implicit: field, owner: field }" />

          <div class="aca-frb__propactions">
            <button type="button" class="aca-frb__outline" (click)="duplicateField()">
              <mat-icon>content_copy</mat-icon>{{ 'DMS.FORMS.DUPLICATE_FIELD' | translate }}
            </button>
            <button type="button" class="aca-frb__danger" (click)="removeField()">
              <mat-icon>delete_outline</mat-icon>{{ 'DMS.FORMS.REMOVE_FIELD' | translate }}
            </button>
          </div>
        </ng-container>

        <!-- a section -->
        <ng-container *ngIf="selection.kind === 'section' && model.sections[selectedSectionIndex] as section">
          <h2 class="aca-frb__panetitle"><mat-icon>view_agenda</mat-icon>{{ 'DMS.FORMS.SECTION' | translate }}</h2>
          <label class="aca-frb__label" for="frb-sectiontitle">{{ 'DMS.FORMS.SECTION_TITLE' | translate }}</label>
          <input id="frb-sectiontitle" class="aca-frb__input" [(ngModel)]="section.title" />
          <span class="aca-frb__label" id="frb-columns-label">{{ 'DMS.FORMS.SECTION_COLUMNS' | translate }}</span>
          <div class="aca-frb__seg" role="radiogroup" aria-labelledby="frb-columns-label">
            <button
              type="button"
              role="radio"
              [attr.aria-checked]="section.columns === 1"
              [class.aca-frb__seg--on]="section.columns === 1"
              (click)="section.columns = 1"
            >
              {{ 'DMS.FORMS.ONE_COLUMN' | translate }}
            </button>
            <button
              type="button"
              role="radio"
              [attr.aria-checked]="section.columns === 2"
              [class.aca-frb__seg--on]="section.columns === 2"
              (click)="section.columns = 2"
            >
              {{ 'DMS.FORMS.TWO_COLUMNS' | translate }}
            </button>
          </div>
          <p class="aca-frb__hint">{{ 'DMS.FORMS.SECTION_HINT' | translate }}</p>
          <ng-container *ngTemplateOutlet="conditionEditor; context: { $implicit: section }" />
        </ng-container>

        <!-- the form -->
        <ng-container *ngIf="selection.kind === 'form'">
          <h2 class="aca-frb__panetitle"><mat-icon>tune</mat-icon>{{ 'DMS.FORMS.SETTINGS' | translate }}</h2>

          <label class="aca-frb__label" for="frb-code">{{ 'DMS.FORMS.CODE' | translate }}</label>
          <input id="frb-code" class="aca-frb__input aca-frb__input--mono" maxlength="12" [(ngModel)]="model.code" placeholder="PO" />
          <span class="aca-frb__hint">{{ 'DMS.FORMS.CODE_HINT' | translate }}</span>

          <h3 class="aca-frb__subtitle">{{ 'DMS.FORMS.OWN_PAPER' | translate }}</h3>
          <div class="aca-frb__paper" *ngIf="model.paper as paper">
            <mat-icon>picture_as_pdf</mat-icon>
            <span class="aca-frb__papername"
              >{{ paper.name || paper.nodeId }}<small>{{ 'DMS.FORMS.OWN_PAPER_PAGES' | translate: { pages: paper.pages.length } }}</small></span
            >
            <button type="button" class="aca-frb__icon" (click)="removePaper()" [attr.aria-label]="'DMS.FORMS.OWN_PAPER_REMOVE' | translate">
              <mat-icon>close</mat-icon>
            </button>
          </div>
          <div class="aca-frb__paperactions">
            <button type="button" class="aca-frb__link" (click)="paperInput.click()" [disabled]="working() === 'paper'">
              <mat-icon>upload_file</mat-icon
              >{{
                (working() === 'paper' ? 'DMS.FORMS.OWN_PAPER_READING' : model.paper ? 'DMS.FORMS.OWN_PAPER_CHANGE' : 'DMS.FORMS.OWN_PAPER_PICK')
                  | translate
              }}
            </button>
            <button type="button" class="aca-frb__link" *ngIf="model.paper" (click)="showTab('paper')">
              <mat-icon>picture_in_picture</mat-icon>{{ 'DMS.FORMS.OWN_PAPER_PLACE' | translate }}
            </button>
            <input
              #paperInput
              type="file"
              accept=".pdf,.png,.jpg,.jpeg,application/pdf,image/png,image/jpeg"
              hidden
              (change)="pickPaper(paperInput)"
            />
          </div>
          <span class="aca-frb__hint">{{ (model.paper ? 'DMS.FORMS.OWN_PAPER_ON' : 'DMS.FORMS.OWN_PAPER_HINT') | translate }}</span>

          <ng-container *ngIf="!model.paper">
            <h3 class="aca-frb__subtitle">{{ 'DMS.FORMS.PAPER' | translate }}</h3>
            <label class="aca-frb__label" for="frb-org">{{ 'DMS.FORMS.ORGANISATION' | translate }}</label>
            <input id="frb-org" class="aca-frb__input" [(ngModel)]="header.organisation" />
            <label class="aca-frb__label" for="frb-orgsub">{{ 'DMS.FORMS.ORGANISATION_SUB' | translate }}</label>
            <input id="frb-orgsub" class="aca-frb__input" [(ngModel)]="header.subtitle" />
            <label class="aca-frb__label" for="frb-signs">{{ 'DMS.FORMS.SIGNATURES' | translate }}</label>
            <textarea
              id="frb-signs"
              class="aca-frb__input aca-frb__input--long"
              rows="3"
              [(ngModel)]="signaturesText"
              [ngModelOptions]="{ updateOn: 'blur' }"
            ></textarea>
            <span class="aca-frb__hint">{{ 'DMS.FORMS.SIGNATURES_HINT' | translate }}</span>
            <label class="aca-frb__label" for="frb-note">{{ 'DMS.FORMS.NOTE' | translate }}</label>
            <textarea id="frb-note" class="aca-frb__input aca-frb__input--long" rows="2" [(ngModel)]="footer.note"></textarea>

            <h3 class="aca-frb__subtitle">{{ 'DMS.FORMS.LOOK' | translate }}</h3>
            <span class="aca-frb__label" id="frb-accent-label">{{ 'DMS.FORMS.ACCENT' | translate }}</span>
            <div class="aca-frb__swatches" role="radiogroup" aria-labelledby="frb-accent-label">
              <button
                type="button"
                role="radio"
                *ngFor="let colour of accents"
                class="aca-frb__swatch"
                [style.background]="colour"
                [class.aca-frb__swatch--on]="(look.accent || accents[0]) === colour"
                [attr.aria-checked]="(look.accent || accents[0]) === colour"
                [attr.aria-label]="colour"
                (click)="look.accent = colour"
              >
                <mat-icon *ngIf="(look.accent || accents[0]) === colour">check</mat-icon>
              </button>
            </div>
            <span class="aca-frb__label">{{ 'DMS.FORMS.LOGO' | translate }}</span>
            <div class="aca-frb__logo">
              <img *ngIf="look.logo" [src]="look.logo" alt="" />
              <button type="button" class="aca-frb__link" (click)="logoInput.click()">
                <mat-icon>image</mat-icon>{{ (look.logo ? 'DMS.FORMS.LOGO_CHANGE' : 'DMS.FORMS.LOGO_PICK') | translate }}
              </button>
              <button
                type="button"
                class="aca-frb__icon"
                *ngIf="look.logo"
                (click)="removeLogo()"
                [attr.aria-label]="'DMS.FORMS.LOGO_REMOVE' | translate"
              >
                <mat-icon>close</mat-icon>
              </button>
              <input #logoInput type="file" accept="image/png,image/jpeg" hidden (change)="pickLogo(logoInput)" />
            </div>
            <span class="aca-frb__hint">{{ 'DMS.FORMS.LOGO_HINT' | translate }}</span>
            <span class="aca-frb__label" id="frb-orientation-label">{{ 'DMS.FORMS.ORIENTATION' | translate }}</span>
            <div class="aca-frb__seg" role="radiogroup" aria-labelledby="frb-orientation-label">
              <button
                type="button"
                role="radio"
                [attr.aria-checked]="look.orientation !== 'landscape'"
                [class.aca-frb__seg--on]="look.orientation !== 'landscape'"
                (click)="look.orientation = 'portrait'"
              >
                {{ 'DMS.FORMS.PORTRAIT' | translate }}
              </button>
              <button
                type="button"
                role="radio"
                [attr.aria-checked]="look.orientation === 'landscape'"
                [class.aca-frb__seg--on]="look.orientation === 'landscape'"
                (click)="look.orientation = 'landscape'"
              >
                {{ 'DMS.FORMS.LANDSCAPE' | translate }}
              </button>
            </div>
            <span class="aca-frb__label" id="frb-density-label">{{ 'DMS.FORMS.DENSITY' | translate }}</span>
            <div class="aca-frb__seg" role="radiogroup" aria-labelledby="frb-density-label">
              <button
                type="button"
                role="radio"
                [attr.aria-checked]="look.density !== 'compact'"
                [class.aca-frb__seg--on]="look.density !== 'compact'"
                (click)="look.density = 'normal'"
              >
                {{ 'DMS.FORMS.DENSITY_NORMAL' | translate }}
              </button>
              <button
                type="button"
                role="radio"
                [attr.aria-checked]="look.density === 'compact'"
                [class.aca-frb__seg--on]="look.density === 'compact'"
                (click)="look.density = 'compact'"
              >
                {{ 'DMS.FORMS.DENSITY_COMPACT' | translate }}
              </button>
            </div>
          </ng-container>

          <h3 class="aca-frb__subtitle">{{ 'DMS.FORMS.FILING' | translate }}</h3>
          <span class="aca-frb__label">{{ 'DMS.FORMS.FOLDER' | translate }}</span>
          <div class="aca-frb__folder">
            <mat-icon>folder</mat-icon>
            <span class="aca-frb__foldername">{{ output.folderName || ('DMS.FORMS.MY_FILES' | translate) }}</span>
            <button type="button" class="aca-frb__link" (click)="pickFolder()">{{ 'DMS.FORMS.CHANGE' | translate }}</button>
            <button
              type="button"
              class="aca-frb__icon"
              *ngIf="output.folderId"
              (click)="clearFolder()"
              [attr.aria-label]="'DMS.FORMS.USE_MY_FILES' | translate"
            >
              <mat-icon>close</mat-icon>
            </button>
          </div>
          <span class="aca-frb__hint">{{ 'DMS.FORMS.FOLDER_HINT' | translate }}</span>

          <ng-container *ngIf="documentTypes.length">
            <label class="aca-frb__label" for="frb-doctype">{{ 'DMS.FORMS.DOCUMENT_TYPE' | translate }}</label>
            <select id="frb-doctype" class="aca-frb__input" [(ngModel)]="output.documentType">
              <option *ngFor="let o of documentTypes" [value]="o.value">{{ o.label | translate }}</option>
            </select>
          </ng-container>
          <ng-container *ngIf="statuses.length">
            <label class="aca-frb__label" for="frb-status">{{ 'DMS.FORMS.DOCUMENT_STATUS' | translate }}</label>
            <select id="frb-status" class="aca-frb__input" [(ngModel)]="output.status">
              <option *ngFor="let o of statuses" [value]="o.value">{{ o.label | translate }}</option>
            </select>
          </ng-container>
          <ng-container *ngIf="confidentialities.length">
            <label class="aca-frb__label" for="frb-conf">{{ 'DMS.FORMS.CONFIDENTIALITY' | translate }}</label>
            <select id="frb-conf" class="aca-frb__input" [(ngModel)]="output.confidentiality">
              <option *ngFor="let o of confidentialities" [value]="o.value">{{ o.label | translate }}</option>
            </select>
          </ng-container>
          <label class="aca-frb__label" for="frb-tags">{{ 'DMS.FORMS.TAGS' | translate }}</label>
          <input id="frb-tags" class="aca-frb__input" [(ngModel)]="tagsText" [ngModelOptions]="{ updateOn: 'blur' }" />
          <span class="aca-frb__hint">{{ 'DMS.FORMS.TAGS_HINT' | translate }}</span>

          <h3 class="aca-frb__subtitle">{{ 'DMS.FORMS.ON_SUBMIT' | translate }}</h3>
          <label class="aca-frb__check" for="frb-sign">
            <input id="frb-sign" type="checkbox" [(ngModel)]="output.sign" />{{ 'DMS.FORMS.SIGN' | translate }}
          </label>
          <span class="aca-frb__hint">{{ 'DMS.FORMS.SIGN_HINT' | translate }}</span>
          <label class="aca-frb__label" for="frb-flow">{{ 'DMS.FORMS.WORKFLOW' | translate }}</label>
          <select id="frb-flow" class="aca-frb__input" [ngModel]="output.workflowId || ''" (ngModelChange)="flowChanged($event)">
            <option value="">{{ 'DMS.FORMS.WORKFLOW_NONE' | translate }}</option>
            <option *ngFor="let flow of flows" [value]="flow.id">{{ flow.name }}</option>
            <option *ngIf="flowGone" [value]="output.workflowId">{{ output.workflowName || output.workflowId }}</option>
          </select>
          <span class="aca-frb__fieldproblem" *ngIf="flowGone" role="alert">{{ 'DMS.FORMS.WORKFLOW_GONE' | translate }}</span>
          <span class="aca-frb__hint" *ngIf="!flowGone && flowsLoaded && !flows.length">{{ 'DMS.FORMS.WORKFLOW_EMPTY' | translate }}</span>
          <span class="aca-frb__hint" *ngIf="!flowGone && output.workflowId">{{ 'DMS.FORMS.WORKFLOW_HINT' | translate }}</span>
        </ng-container>
      </aside>
    </div>
  </ng-container>
</div>

<!-- "show only when ...", for a field or a whole section -->
<ng-template #conditionEditor let-target let-owner="owner">
  <h3 class="aca-frb__subtitle">{{ 'DMS.FORMS.SHOW_IF' | translate }}</h3>
  <div class="aca-frb__seg" role="radiogroup" [attr.aria-label]="'DMS.FORMS.SHOW_IF' | translate">
    <button
      type="button"
      role="radio"
      [attr.aria-checked]="!target.showIf"
      [class.aca-frb__seg--on]="!target.showIf"
      (click)="setConditional(target, false)"
    >
      {{ 'DMS.FORMS.SHOW_ALWAYS' | translate }}
    </button>
    <button
      type="button"
      role="radio"
      [attr.aria-checked]="!!target.showIf"
      [class.aca-frb__seg--on]="!!target.showIf"
      [disabled]="!conditionSources(owner).length"
      (click)="target.showIf || setConditional(target, true, owner)"
    >
      {{ 'DMS.FORMS.SHOW_WHEN' | translate }}
    </button>
  </div>
  <div class="aca-frb__cond" *ngIf="target.showIf as condition">
    <label class="aca-frb__label" for="frb-cond-field">{{ 'DMS.FORMS.CONDITION_FIELD' | translate }}</label>
    <select id="frb-cond-field" class="aca-frb__input" [(ngModel)]="condition.field" (ngModelChange)="conditionFieldChanged(condition)">
      <option *ngFor="let source of conditionSources(owner)" [value]="source.key">{{ source.label || source.key }}</option>
    </select>
    <label class="aca-frb__label" for="frb-cond-op">{{ 'DMS.FORMS.CONDITION_OP' | translate }}</label>
    <select id="frb-cond-op" class="aca-frb__input" [(ngModel)]="condition.op">
      <option *ngFor="let op of conditionOps(condition)" [value]="op">{{ opLabel(condition, op) }}</option>
    </select>
    <ng-container *ngIf="needsValue(condition)">
      <label class="aca-frb__label" for="frb-cond-value">{{ 'DMS.FORMS.CONDITION_VALUE' | translate }}</label>
      <select
        id="frb-cond-value"
        class="aca-frb__input"
        *ngIf="conditionSource(condition)?.options?.length; else freeValue"
        [(ngModel)]="condition.value"
      >
        <option *ngFor="let option of conditionSource(condition)?.options" [value]="option">{{ option }}</option>
      </select>
      <ng-template #freeValue>
        <input id="frb-cond-value" class="aca-frb__input" [(ngModel)]="condition.value" />
      </ng-template>
    </ng-container>
    <span class="aca-frb__fieldproblem" *ngIf="conditionProblem(condition, owner) as problem" role="alert"
      ><mat-icon>error_outline</mat-icon>{{ problem }}</span
    >
    <span class="aca-frb__hint">{{ 'DMS.FORMS.SHOW_IF_HINT' | translate }}</span>
  </div>
</ng-template>
